/*@flow*/
import type { TypeT } from 'lib/t/types';
import type { PathT } from '../types';
import assert from 'lib/t/assert';
import stringify from 'lib/t/stringify';
import isNumber from 'lib/t/isNumber';
import getTypeInfo from './getTypeInfo';
import getTypeFromUnion from './getTypeFromUnion';
import * as I from 'immutable';

export default function getTypeAtPath(
  type: TypeT<*>,
  path: PathT,
  rootValue: any,
  originalPath: PathT = []
): TypeT<*> {
  if (process.env.NODE_ENV !== 'production') {
    assert(
      Boolean(type),
      () =>
        `Type must be present. Missing a type at ${stringify(
          path
        )}. Type: ${stringify(type)}`
    );
  }

  let ret;
  if (path.length === 0) {
    ret = type;
  } else {
    const typeInfo = getTypeInfo(type);
    const { innerType } = typeInfo;

    if (!innerType) {
      ret = type;
    } else {
      const { meta } = innerType;
      const k = path[0];
      const path2this = path.slice(1);

      switch (meta.kind) {
        case 'struct':
          if (isNumber(k)) {
            ret = getTypeAtPath(innerType, path2this, rootValue, path);
          } else if (!meta.props[k]) {
            throw new Error(
              `Missing: ${k} in ${stringify(meta.props)}. Path: ${stringify(
                path
              )}. Meta: ${stringify(meta)}. Type: ${stringify(typeInfo)}`
            );
          } else {
            ret = getTypeAtPath(meta.props[k], path2this, rootValue, path);
          }
          break;
        case 'list':
          ret = getTypeAtPath(meta.type, path2this, rootValue, path);
          break;
        default:
          if (isNumber(k)) {
            // TODO: test
            ret = getTypeAtPath(innerType, path2this, rootValue, path);
          } else {
            ret = innerType;
          }
          break;
      }
    }
  }

  // $FlowFixMe[incompatible-call]
  return (getTypeFromUnion(ret, I.getIn(rootValue, originalPath)): any);
}
